<div
  class="d-flex surface-back radius-medium p-minus pr-medium gap-minus align-items-center cursor-pointer"
  commonUtilitiesAppletOnHold
  (handleOnHold)="more()"
  (click)="handleClick($event)"
>
  <div class="img-background">
    <ui-api-image
      [styles]="{ borderRadius: '50%' }"
      [imageId]="icon"
      [width]="'24px'"
      [height]="'24px'"
    ></ui-api-image>
  </div>

  <div class="d-flex flex-column flex-basis-1">
    <span class="c-2 text-onback-medium lh-20">{{ item.title }}</span>
    <div class="d-flex gap-tiny lh-16">
      <span class="text-onback-low l-3">{{ item.subTitle }}</span>
      <span class="text-onback-low l-3">{{ amount | thousands }} ریال</span>
    </div>
  </div>
  <div class="d-flex align-items-center gap-tiny mr-auto">
    <common-ui-components-temp-ngx-button
      *ngIf="clickable"
      [style]="'link'"
      [size]="'small'"
      [mode]="'icon-only'"
      [leftIcon]="{ name: 'Arrow-Left', type: 'linear' }"
    >
    </common-ui-components-temp-ngx-button>
  </div>
</div>
